import { QueryClient, QueryClientProvider, type QueryClientConfig } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState, type ReactNode } from 'react';

/** Exported so tests can assert against the real app-wide defaults rather than a second,
 *  independently-typed copy that could silently drift from what `<QueryProvider>` actually sets. */
export const queryClientDefaultOptions: NonNullable<QueryClientConfig['defaultOptions']> = {
  queries: {
    staleTime: 30_000,
    retry: 1,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  },
  mutations: { retry: 0 },
};

export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(() => new QueryClient({ defaultOptions: queryClientDefaultOptions }));

  return (
    <QueryClientProvider client={client}>
      {children}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
